module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/graff.1a74396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/graff.jpg
// module id = YVdK
// module chunks = 0